/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BaseSearchFilterElementDto } from './BaseSearchFilterElementDto';

export type IncidentStatusSearchFilterElementDto = (BaseSearchFilterElementDto & {
    id?: IncidentStatusSearchFilterElementDto.id;
});

export namespace IncidentStatusSearchFilterElementDto {

    export enum id {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        CLOSED = 'CLOSED',
    }


}
